interface GuestSession {
    token: string;
    folderKey: string;
}

const GUEST_STORAGE_KEY = 'guestuser__session';
const COOKIE_EXPIRY_DAYS = 1;

const setCookie = (name: string, value: string, days: number) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}${expires}; path=/; SameSite=Strict`;
};

const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
};

const deleteCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
};

export const saveGuestSession = (session: GuestSession) => {
    setCookie(`${GUEST_STORAGE_KEY}`, JSON.stringify(session), COOKIE_EXPIRY_DAYS);
};

export const getGuestSession = (): GuestSession | null => {
    const raw = getCookie(`${GUEST_STORAGE_KEY}`);

    if (!raw) {
        return null;
    }

    try {
        const session = JSON.parse(raw) as GuestSession;
        return session;
    } catch (err) {
        clearGuestSession();
        return null;
    }
};

export const clearGuestSession = () => {
    deleteCookie(GUEST_STORAGE_KEY);
};
